// extracted by mini-css-extract-plugin
export default {"daterange":"daterange--JXyfZ","label":"label--hT6C3"};